const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const CopyTable = require("../util/CopyTable");
const AssetsUtil = require("../util/AssetsUtil");
const WonkyButton = require("./WonkyButton");
const URLMake = require("../../../shared/URLMake");
const withVaultDispatch = require("../hoc/withVaultDispatch");
const AT = require("../vault/ActionTypes");

const styles = require("./styles/ErrorMessage.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "ErrorMessage",

		propTypes: {
			standardMessage: PT.oneOf(Object.keys(CopyTable.standardErrorMessages)),
			// If customMessage passed, standardMessage is ignored.
			customMessage: PT.string,
			className: PT.string,
			withRefresh: PT.bool,
			isOffice: PT.bool,
			isFull: PT.bool,
			reloadFunction: PT.func,
			withLogout: PT.bool,
			withHome: PT.bool,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		getDefaultProps: function() {
			return {
				standardMessage: "refresh",
				image: "problems",
				className: "",
				withRefresh: true,
			};
		},

		refresh: function() {
			if (this.props.reloadFunction) {
				this.props.reloadFunction();
			} else {
				window.location.reload();
			}
		},

		logout: function() {
			this.props.dispatch({
				type: AT.LOGOUT_USER_REQUEST,
				logoutPage: this.props.isOffice
					? {name: "office.main"}
					: {name: "home.login"},
			});
		},

		goToOfficeHome: function() {
			const pageState = URLMake.state.forOffice();
			this.props.dispatch({
				type: AT.SET_PAGE,
				pageState,
				addToHistory: true,
			});
		},

		render: function() {
			const {
				customMessage,
				standardMessage,
				className,
				isOffice,
				isFull,
				withLogout,
				withRefresh,
				withHome,
			} = this.props;
			const message =
				customMessage || CopyTable.forStandardError(standardMessage);
			let mainClass = styles.container;
			if (isOffice && isFull) {
				mainClass = styles.containerOfficeFull;
			} else if (isOffice) {
				mainClass = styles.containerOfficeSmall;
			}
			const topClassNames = mainClass + " " + className;

			let refreshButton = null;
			let refreshOfficeButton = null;
			let logoutButton = null;
			let logoutOfficeButton = null;
			let homeOfficeButton = null;
			if (withHome && isOffice) {
				homeOfficeButton = (
					<div className={styles.officeButton} onClick={this.goToOfficeHome}>
						Home Page
					</div>
				);
			} else {
				if (withRefresh) {
					if (isOffice) {
						refreshOfficeButton = (
							<div className={styles.officeButton} onClick={this.refresh}>
								Try Again
							</div>
						);
					} else {
						refreshButton = (
							<WonkyButton
								className={styles.trainerButton}
								buttonType="tryagain"
								handleClick={this.refresh}
							/>
						);
					}
				}
				if (withLogout) {
					if (isOffice) {
						logoutOfficeButton = (
							<div className={styles.officeButton} onClick={this.logout}>
								Sign Out
							</div>
						);
					} else {
						logoutButton = (
							<WonkyButton
								className={styles.trainerButton}
								buttonType="logout"
								handleClick={this.logout}
							/>
						);
					}
				}
			}

			const img = (
				<img className={styles.image} src={AssetsUtil.getGotProblems()} />
			);

			return (
				<div className={topClassNames}>
					{img}
					<div className={styles.message}>
						{message}
						<div className={styles.officeButtons}>
							{refreshOfficeButton}
							{logoutOfficeButton}
							{homeOfficeButton}
						</div>
					</div>
					<div className={styles.trainerButtons}>
						{refreshButton}
						{logoutButton}
					</div>
				</div>
			);
		},
	})
);
